import React from 'react';
import PropTypes from 'prop-types';

export function StarIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.04894 0.927052C6.3483 0.0057416 7.6517 0.00574088 7.95106 0.927052L8.79611 3.52786C8.92999 3.93989 9.31394 4.21885 9.74717 4.21885H12.4818C13.4505 4.21885 13.8533 5.45846 13.0696 6.02786L10.8572 7.63525C10.5067 7.8899 10.3601 8.34127 10.494 8.75329L11.339 11.3541C11.6384 12.2754 10.5839 13.0415 9.80017 12.4721L7.58779 10.8647C7.2373 10.6101 6.7627 10.6101 6.41222 10.8647L4.19983 12.4721C3.41612 13.0415 2.36164 12.2754 2.66099 11.3541L3.50604 8.75329C3.63992 8.34127 3.49326 7.8899 3.14277 7.63525L0.930391 6.02787C0.146677 5.45846 0.549452 4.21885 1.51818 4.21885H4.25283C4.68606 4.21885 5.07001 3.93989 5.20389 3.52786L6.04894 0.927052Z"
        fill={color}
      />
    </svg>
  );
}
StarIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
StarIcon.defaultProps = {
  color: '#3B86F2',
  size: '0.972vw',
};
export function HalfStarIcon({ color, fillColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.064 2.29461L6.93861 6.60398L2.18334 7.29725C1.33058 7.42093 0.988822 8.47223 1.60724 9.07437L5.04757 12.4268L4.23386 17.1626C4.0874 18.0186 4.98898 18.6598 5.74409 18.2594L9.99813 16.0234L14.2522 18.2594C15.0073 18.6565 15.9089 18.0186 15.7624 17.1626L14.9487 12.4268L18.389 9.07437C19.0074 8.47223 18.6657 7.42093 17.8129 7.29725L13.0576 6.60398L10.9323 2.29461C10.5514 1.52648 9.44806 1.51671 9.064 2.29461Z"
        fill={fillColor}
      />
      <path
        d="M10.0004 1.71484C9.62925 1.71484 9.2581 1.90693 9.06602 2.29435L6.94008 6.60484L2.18357 7.29504C1.33059 7.41875 0.988744 8.47033 1.60732 9.07262L5.04854 12.4259L4.23463 17.1629C4.08813 18.0126 4.98343 18.6605 5.74525 18.2601L10.0004 16.0267V1.71484Z"
        fill={color}
      />
    </svg>
  );
}
HalfStarIcon.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string,
  size: PropTypes.string,
};
HalfStarIcon.defaultProps = {
  color: '#F2C94C',
  fillColor: '#E5E9F2',
  size: '20',
};
export function CallIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6335 15.1668C10.8802 15.1668 10.0868 14.9868 9.26683 14.6402C8.46683 14.3002 7.66016 13.8335 6.8735 13.2668C6.0935 12.6935 5.34016 12.0535 4.62683 11.3535C3.92016 10.6402 3.28016 9.88683 2.7135 9.1135C2.14016 8.3135 1.68016 7.5135 1.3535 6.74016C1.00683 5.9135 0.833496 5.1135 0.833496 4.36016C0.833496 3.84016 0.926829 3.34683 1.10683 2.88683C1.2935 2.4135 1.5935 1.9735 2.00016 1.5935C2.5135 1.08683 3.10016 0.833496 3.72683 0.833496C3.98683 0.833496 4.2535 0.893496 4.48016 1.00016C4.74016 1.12016 4.96016 1.30016 5.12016 1.54016L6.66683 3.72016C6.80683 3.9135 6.9135 4.10016 6.98683 4.28683C7.0735 4.48683 7.12016 4.68683 7.12016 4.88016C7.12016 5.1335 7.04683 5.38016 6.90683 5.6135C6.80683 5.7935 6.6535 5.98683 6.46016 6.18016L6.00683 6.6535C6.0135 6.6735 6.02016 6.68683 6.02683 6.70016C6.10683 6.84016 6.26683 7.08016 6.5735 7.44016C6.90016 7.8135 7.20683 8.1535 7.5135 8.46683C7.90683 8.8535 8.2335 9.16016 8.54016 9.4135C8.92016 9.7335 9.16683 9.8935 9.3135 9.96683L9.30016 10.0002L9.78683 9.52016C9.9935 9.3135 10.1935 9.16016 10.3868 9.06016C10.7535 8.8335 11.2202 8.7935 11.6868 8.98683C11.8602 9.06016 12.0468 9.16016 12.2468 9.30016L14.4602 10.8735C14.7068 11.0402 14.8868 11.2535 14.9935 11.5068C15.0935 11.7602 15.1402 11.9935 15.1402 12.2268C15.1402 12.5468 15.0668 12.8668 14.9268 13.1668C14.7868 13.4668 14.6135 13.7268 14.3935 13.9668C14.0135 14.3868 13.6002 14.6868 13.1202 14.8802C12.6602 15.0668 12.1602 15.1668 11.6335 15.1668ZM3.72683 1.8335C3.36016 1.8335 3.02016 1.9935 2.6935 2.3135C2.38683 2.60016 2.1735 2.9135 2.04016 3.2535C1.90016 3.60016 1.8335 3.96683 1.8335 4.36016C1.8335 4.98016 1.98016 5.6535 2.2735 6.34683C2.5735 7.0535 2.9935 7.78683 3.52683 8.52016C4.06016 9.2535 4.66683 9.96683 5.3335 10.6402C6.00016 11.3002 6.72016 11.9135 7.46016 12.4535C8.18016 12.9802 8.92016 13.4068 9.6535 13.7135C10.7935 14.2002 11.8602 14.3135 12.7402 13.9468C13.0802 13.8068 13.3802 13.5935 13.6535 13.2868C13.8068 13.1202 13.9268 12.9402 14.0268 12.7268C14.1068 12.5602 14.1468 12.3868 14.1468 12.2135C14.1468 12.1068 14.1268 12.0002 14.0735 11.8802C14.0535 11.8402 14.0135 11.7668 13.8868 11.6802L11.6735 10.1068C11.5402 10.0135 11.4202 9.94683 11.3068 9.90016C11.1602 9.84016 11.1002 9.78016 10.8735 9.92016C10.7402 9.98683 10.6202 10.0868 10.4868 10.2202L9.98016 10.7202C9.72016 10.9735 9.32016 11.0335 9.0135 10.9202L8.8335 10.8402C8.56016 10.6935 8.24016 10.4668 7.88683 10.1668C7.56683 9.8935 7.22016 9.5735 6.80016 9.16016C6.4735 8.82683 6.14683 8.4735 5.80683 8.08016C5.4935 7.7135 5.26683 7.40016 5.12683 7.14016L5.04683 6.94016C5.00683 6.78683 4.9935 6.70016 4.9935 6.60683C4.9935 6.36683 5.08016 6.1535 5.24683 5.98683L5.74683 5.46683C5.88016 5.3335 5.98016 5.20683 6.04683 5.0935C6.10016 5.00683 6.12016 4.9335 6.12016 4.86683C6.12016 4.8135 6.10016 4.7335 6.06683 4.6535C6.02016 4.54683 5.94683 4.42683 5.8535 4.30016L4.30683 2.1135C4.24016 2.02016 4.16016 1.9535 4.06016 1.90683C3.9535 1.86016 3.84016 1.8335 3.72683 1.8335ZM9.30016 10.0068L9.1935 10.4602L9.3735 9.9935C9.34016 9.98683 9.3135 9.9935 9.30016 10.0068Z"
        fill="#3B86F2"
      />
    </svg>
  );
}
export function WebsiteIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00016 15.1668C4.04683 15.1668 0.833496 11.9535 0.833496 8.00016C0.833496 4.04683 4.04683 0.833496 8.00016 0.833496C11.9535 0.833496 15.1668 4.04683 15.1668 8.00016C15.1668 11.9535 11.9535 15.1668 8.00016 15.1668ZM8.00016 1.8335C4.60016 1.8335 1.8335 4.60016 1.8335 8.00016C1.8335 11.4002 4.60016 14.1668 8.00016 14.1668C11.4002 14.1668 14.1668 11.4002 14.1668 8.00016C14.1668 4.60016 11.4002 1.8335 8.00016 1.8335Z"
        fill="#3B86F2"
      />
      <path
        d="M6.00016 14.5H5.33349C5.06016 14.5 4.83349 14.2733 4.83349 14C4.83349 13.7267 5.04682 13.5067 5.32016 13.5C4.27349 9.92667 4.27349 6.07333 5.32016 2.5C5.04682 2.49333 4.83349 2.27333 4.83349 2C4.83349 1.72667 5.06016 1.5 5.33349 1.5H6.00016C6.16016 1.5 6.31349 1.58 6.40682 1.70667C6.50016 1.84 6.52682 2.00667 6.47349 2.16C5.22016 5.92667 5.22016 10.0733 6.47349 13.8467C6.52682 14 6.50016 14.1667 6.40682 14.3C6.31349 14.42 6.16016 14.5 6.00016 14.5Z"
        fill="#3B86F2"
      />
      <path
        d="M10.0001 14.4998C9.94677 14.4998 9.89344 14.4931 9.8401 14.4731C9.5801 14.3865 9.43344 14.0998 9.52677 13.8398C10.7801 10.0731 10.7801 5.92646 9.52677 2.15313C9.4401 1.89313 9.5801 1.60646 9.8401 1.51979C10.1068 1.43313 10.3868 1.57313 10.4734 1.83313C11.8001 5.80646 11.8001 10.1798 10.4734 14.1465C10.4068 14.3665 10.2068 14.4998 10.0001 14.4998Z"
        fill="#3B86F2"
      />
      <path
        d="M8 11.4667C6.14 11.4667 4.28667 11.2067 2.5 10.68C2.49333 10.9467 2.27333 11.1667 2 11.1667C1.72667 11.1667 1.5 10.94 1.5 10.6667V10C1.5 9.84003 1.58 9.68669 1.70667 9.59336C1.84 9.50003 2.00667 9.47336 2.16 9.52669C5.92667 10.78 10.08 10.78 13.8467 9.52669C14 9.47336 14.1667 9.50003 14.3 9.59336C14.4333 9.68669 14.5067 9.84003 14.5067 10V10.6667C14.5067 10.94 14.28 11.1667 14.0067 11.1667C13.7333 11.1667 13.5133 10.9534 13.5067 10.68C11.7133 11.2067 9.86 11.4667 8 11.4667Z"
        fill="#3B86F2"
      />
      <path
        d="M14 6.50007C13.9467 6.50007 13.8934 6.4934 13.84 6.4734C10.0734 5.22007 5.92002 5.22007 2.15335 6.4734C1.88669 6.56007 1.60669 6.42007 1.52002 6.16007C1.44002 5.8934 1.58002 5.6134 1.84002 5.52674C5.81335 4.20007 10.1867 4.20007 14.1534 5.52674C14.4134 5.6134 14.56 5.90007 14.4667 6.16007C14.4067 6.36674 14.2067 6.50007 14 6.50007Z"
        fill="#3B86F2"
      />
    </svg>
  );
}
export function SMSIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 14.1668H4.66683C2.2335 14.1668 0.833496 12.7668 0.833496 10.3335V5.66683C0.833496 3.2335 2.2335 1.8335 4.66683 1.8335H11.3335C13.7668 1.8335 15.1668 3.2335 15.1668 5.66683V10.3335C15.1668 12.7668 13.7668 14.1668 11.3335 14.1668ZM4.66683 2.8335C2.76016 2.8335 1.8335 3.76016 1.8335 5.66683V10.3335C1.8335 12.2402 2.76016 13.1668 4.66683 13.1668H11.3335C13.2402 13.1668 14.1668 12.2402 14.1668 10.3335V5.66683C14.1668 3.76016 13.2402 2.8335 11.3335 2.8335H4.66683Z"
        fill={color}
      />
      <path
        d="M7.99969 8.57998C7.43969 8.57998 6.87302 8.40665 6.43969 8.05331L4.35302 6.38665C4.13969 6.21331 4.09969 5.89998 4.27302 5.68665C4.44636 5.47331 4.75969 5.43332 4.97303 5.60665L7.05969 7.27332C7.56635 7.67998 8.42635 7.67998 8.93302 7.27332L11.0197 5.60665C11.233 5.43332 11.553 5.46665 11.7197 5.68665C11.893 5.89998 11.8597 6.21998 11.6397 6.38665L9.55302 8.05331C9.12636 8.40665 8.55969 8.57998 7.99969 8.57998Z"
        fill={color}
      />
    </svg>
  );
}
SMSIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
SMSIcon.defaultProps = {
  color: '#3B86F2',
  size: '1.111vw',
};
export function ComboShape({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 0C19.067 0 17.5 1.567 17.5 3.5V7C17.5 8.933 19.067 10.5 21 10.5H24.5C26.433 10.5 28 8.933 28 7V3.5C28 1.567 26.433 0 24.5 0H21ZM3.5 17.5C1.567 17.5 0 19.067 0 21V24.5C0 26.433 1.567 28 3.5 28H7C8.933 28 10.5 26.433 10.5 24.5V21C10.5 19.067 8.933 17.5 7 17.5H3.5ZM0 3.5C0 1.567 1.567 0 3.5 0H7C8.933 0 10.5 1.567 10.5 3.5V7C10.5 8.933 8.933 10.5 7 10.5H3.5C1.567 10.5 0 8.933 0 7V3.5ZM21 17.5C19.067 17.5 17.5 19.067 17.5 21V24.5C17.5 26.433 19.067 28 21 28H24.5C26.433 28 28 26.433 28 24.5V21C28 19.067 26.433 17.5 24.5 17.5H21Z"
        fill={color}
      />
    </svg>
  );
}
ComboShape.propTypes = {
  color: PropTypes.string,
};
ComboShape.defaultProps = {
  color: '#4A5568',
};
export function LocationShape({ color }) {
  return (
    <svg
      width="32"
      height="36"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 35.2715C21.9062 35.2715 31.75 24.4605 31.75 15.903C31.75 7.34546 24.6985 0.408203 16 0.408203C7.30151 0.408203 0.25 7.34546 0.25 15.903C0.25 24.4605 10.0938 35.2715 16 35.2715ZM16 21.3262C18.8995 21.3262 21.25 18.9848 21.25 16.0967C21.25 13.2085 18.8995 10.8672 16 10.8672C13.1005 10.8672 10.75 13.2085 10.75 16.0967C10.75 18.9848 13.1005 21.3262 16 21.3262Z"
        fill={color}
      />
    </svg>
  );
}
LocationShape.propTypes = {
  color: PropTypes.string,
};
LocationShape.defaultProps = {
  color: '#7D7D7D',
};
export function WalletIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 11.8999H7C6.59 11.8999 6.25 11.5599 6.25 11.1499C6.25 10.7399 6.59 10.3999 7 10.3999H13C13.41 10.3999 13.75 10.7399 13.75 11.1499C13.75 11.5599 13.41 11.8999 13 11.8999Z"
        fill="#3B86F2"
      />
      <path
        d="M2 11.8998C1.59 11.8998 1.25 11.5598 1.25 11.1498V6.52985C1.25 4.07985 3.24 2.08984 5.69 2.08984H11.31C13.88 2.08984 15.75 3.79984 15.75 6.14984C15.75 6.55984 15.41 6.89984 15 6.89984C14.59 6.89984 14.25 6.55984 14.25 6.14984C14.25 4.38984 12.72 3.58984 11.31 3.58984H5.69C4.07 3.58984 2.75 4.90985 2.75 6.52985V11.1498C2.75 11.5698 2.41 11.8998 2 11.8998Z"
        fill="#3B86F2"
      />
      <path
        d="M16 21.8999H6C3.38 21.8999 1.25 19.7699 1.25 17.1499V10.1499C1.25 7.5299 3.38 5.3999 6 5.3999H16C18.62 5.3999 20.75 7.5299 20.75 10.1499V11.5999C20.75 12.0099 20.41 12.3499 20 12.3499H18.92C18.57 12.3499 18.25 12.4798 18.02 12.7198L18.01 12.7299C17.68 13.0599 17.55 13.5198 17.67 13.9698C17.82 14.5298 18.41 14.9399 19.07 14.9399H20C20.41 14.9399 20.75 15.2799 20.75 15.6899V17.1399C20.75 19.7699 18.62 21.8999 16 21.8999ZM6 6.8999C4.21 6.8999 2.75 8.3599 2.75 10.1499V17.1499C2.75 18.9399 4.21 20.3999 6 20.3999H16C17.79 20.3999 19.25 18.9399 19.25 17.1499V16.4499H19.07C17.72 16.4499 16.55 15.5999 16.22 14.3699C15.96 13.3999 16.24 12.3699 16.95 11.6699C17.47 11.1399 18.17 10.8499 18.92 10.8499H19.25V10.1499C19.25 8.3599 17.79 6.8999 16 6.8999H6Z"
        fill="#3B86F2"
      />
      <path
        d="M20.9699 16.4501H19.0399C17.5299 16.4501 16.2499 15.3301 16.1299 13.8901C16.0499 13.0601 16.3499 12.2501 16.9499 11.6601C17.4499 11.1401 18.1599 10.8501 18.9099 10.8501H20.9599C21.9399 10.8501 22.7399 11.6401 22.7399 12.6201V14.6801C22.7499 15.6601 21.9499 16.4501 20.9699 16.4501ZM18.9199 12.3501C18.5699 12.3501 18.2499 12.4801 18.0199 12.7201C17.7299 13.0001 17.5899 13.3801 17.6299 13.7601C17.6799 14.4201 18.3199 14.9501 19.0399 14.9501H20.9699C21.1199 14.9501 21.2499 14.8301 21.2499 14.6801V12.6201C21.2499 12.4701 21.1199 12.3501 20.9699 12.3501H18.9199Z"
        fill="#3B86F2"
      />
    </svg>
  );
}
export function HambargerIcon() {
  return (
    <svg
      width="2.917vw"
      height="2.986vw"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.75 10.1074H5.25C4.5325 10.1074 3.9375 9.51242 3.9375 8.79492C3.9375 8.07742 4.5325 7.48242 5.25 7.48242H36.75C37.4675 7.48242 38.0625 8.07742 38.0625 8.79492C38.0625 9.51242 37.4675 10.1074 36.75 10.1074Z"
        fill="#7D7D7D"
      />
      <path
        d="M36.75 18.8574H5.25C4.5325 18.8574 3.9375 18.2624 3.9375 17.5449C3.9375 16.8274 4.5325 16.2324 5.25 16.2324H36.75C37.4675 16.2324 38.0625 16.8274 38.0625 17.5449C38.0625 18.2624 37.4675 18.8574 36.75 18.8574Z"
        fill="#7D7D7D"
      />
      <path
        d="M36.75 27.6074H5.25C4.5325 27.6074 3.9375 27.0124 3.9375 26.2949C3.9375 25.5774 4.5325 24.9824 5.25 24.9824H36.75C37.4675 24.9824 38.0625 25.5774 38.0625 26.2949C38.0625 27.0124 37.4675 27.6074 36.75 27.6074Z"
        fill="#7D7D7D"
      />
      <path
        d="M36.75 36.3574H5.25C4.5325 36.3574 3.9375 35.7624 3.9375 35.0449C3.9375 34.3274 4.5325 33.7324 5.25 33.7324H36.75C37.4675 33.7324 38.0625 34.3274 38.0625 35.0449C38.0625 35.7624 37.4675 36.3574 36.75 36.3574Z"
        fill="#7D7D7D"
      />
    </svg>
  );
}
export function SliderArrowRight({ color }) {
  return (
    <svg
      width="71"
      height="90"
      viewBox="0 0 71 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_372_13679)">
        <path
          d="M50.2417 13.8889C50.3031 12.5096 51.471 11.4411 52.8503 11.5025C54.2297 11.5638 55.2981 12.7317 55.2368 14.1111L50.2417 13.8889ZM17.3558 64.9253C16.0217 64.5694 15.2288 63.1994 15.5847 61.8653L21.3848 40.1258C21.7407 38.7917 23.1107 37.9988 24.4447 38.3547C25.7788 38.7106 26.5717 40.0806 26.2158 41.4147L21.0602 60.7387L40.3843 65.8944C41.7183 66.2503 42.5112 67.6203 42.1553 68.9543C41.7994 70.2884 40.4294 71.0813 39.0954 70.7254L17.3558 64.9253ZM55.2368 14.1111C54.5976 28.4827 51.3054 38.0077 45.0805 45.5814C38.9657 53.0211 30.1801 58.3489 19.2526 64.6735L16.7479 60.3461C27.8123 53.9422 35.7727 49.0314 41.2178 42.4066C46.5527 35.9157 49.6341 27.5501 50.2417 13.8889L55.2368 14.1111Z"
          fill={color !== '' ? color : '#C9C9C9'}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_372_13679"
          x="0.499512"
          y="0.5"
          width="69.7397"
          height="89.3105"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_372_13679"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_372_13679"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
SliderArrowRight.propTypes = {
  color: PropTypes.string,
};
SliderArrowRight.defaultProps = {
  color: '',
};
export function SliderArrowLeft({ color }) {
  return (
    <svg
      width="82"
      height="85"
      viewBox="0 0 82 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_372_13678)">
        <path
          d="M20.5927 13.2528C20.1801 11.9352 18.7774 11.2016 17.4598 11.6143C16.1422 12.027 15.4086 13.4296 15.8213 14.7472L20.5927 13.2528ZM65.448 54.1702C66.6466 53.4849 67.0627 51.9576 66.3773 50.759L55.2083 31.2269C54.5229 30.0283 52.9957 29.6122 51.7971 30.2976C50.5985 30.983 50.1824 32.5103 50.8678 33.7089L60.7958 51.0708L43.4339 60.9987C42.2353 61.6841 41.8193 63.2114 42.5047 64.41C43.19 65.6085 44.7173 66.0246 45.9159 65.3392L65.448 54.1702ZM15.8213 14.7472C20.1206 28.4737 25.7422 36.8372 33.6981 42.565C41.5133 48.1915 51.3689 51.0939 63.55 54.4121L64.8641 49.5879C52.5305 46.2281 43.579 43.5177 36.6194 38.5072C29.8005 33.598 24.6795 26.3006 20.5927 13.2528L15.8213 14.7472Z"
          fill={color !== '' ? color : '#C9C9C9'}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_372_13678"
          x="0.706543"
          y="0.499512"
          width="81.001"
          height="84.1699"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_372_13678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_372_13678"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
SliderArrowLeft.propTypes = {
  color: PropTypes.string,
};
SliderArrowLeft.defaultProps = {
  color: '',
};
export function EntityIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29165 13.7708H2.37998C1.46415 13.7708 0.711647 13.0358 0.711647 12.1258V3.46917C0.711647 2.57667 1.04415 1.88251 1.65081 1.50334C2.26331 1.11834 3.05665 1.13001 3.87915 1.53834L6.46915 2.81001C7.17498 3.16001 7.72915 4.04084 7.72915 4.82251V13.3333C7.72915 13.5725 7.53081 13.7708 7.29165 13.7708ZM2.65998 2.10417C2.45581 2.10417 2.26915 2.15084 2.11165 2.25001C1.77331 2.46001 1.58665 2.89751 1.58665 3.46917V12.1258C1.58665 12.5517 1.94248 12.8958 2.37998 12.8958H6.85415V4.82251C6.85415 4.37334 6.49248 3.79584 6.07831 3.59751L3.48831 2.32584C3.19081 2.18001 2.91081 2.10417 2.65998 2.10417Z"
        fill={color}
      />
      <path
        d="M10.9725 13.7708H7.29166C7.0525 13.7708 6.85416 13.5725 6.85416 13.3333V6.57833C6.85416 6.44416 6.9125 6.32166 7.0175 6.23999C7.1225 6.15833 7.25083 6.12333 7.385 6.15249L7.65916 6.21083L11.4742 7.06249C12.635 7.31916 13.2183 8.00166 13.2533 9.16249C13.2592 9.16249 13.2592 9.22083 13.2592 9.28499V11.49C13.2533 12.9833 12.4658 13.7708 10.9725 13.7708ZM7.72916 12.8958H10.9725C11.9992 12.8958 12.3783 12.5167 12.3783 11.49V9.23833C12.3492 8.43916 12.0458 8.08333 11.2817 7.91416L7.72916 7.12083V12.8958Z"
        fill={color}
      />
      <path
        d="M5.2325 6.1875H3.20834C2.96917 6.1875 2.77084 5.98917 2.77084 5.75C2.77084 5.51083 2.96917 5.3125 3.20834 5.3125H5.2325C5.47167 5.3125 5.67 5.51083 5.67 5.75C5.67 5.98917 5.4775 6.1875 5.2325 6.1875Z"
        fill={color}
      />
      <path
        d="M5.2325 8.52081H3.20834C2.96917 8.52081 2.77084 8.32248 2.77084 8.08331C2.77084 7.84415 2.96917 7.64581 3.20834 7.64581H5.2325C5.47167 7.64581 5.67 7.84415 5.67 8.08331C5.67 8.32248 5.4775 8.52081 5.2325 8.52081Z"
        fill={color}
      />
      <path
        d="M8.87832 10.8542C7.91582 10.8542 7.12832 10.0667 7.12832 9.1042V6.6367C7.12832 6.50253 7.18665 6.38003 7.29165 6.29253C7.39665 6.20503 7.53082 6.17586 7.65915 6.20503L10.2842 6.7942C10.4825 6.84086 10.6283 7.01586 10.6283 7.22003V9.09836C10.6283 10.0667 9.84665 10.8542 8.87832 10.8542ZM8.00332 7.18503V9.1042C8.00332 9.58836 8.39415 9.9792 8.87832 9.9792C9.36249 9.9792 9.75332 9.58836 9.75332 9.1042V7.57586L8.00332 7.18503Z"
        fill={color}
      />
      <path
        d="M11.5033 10.8542C10.5408 10.8542 9.75332 10.0667 9.75332 9.10418V7.22585C9.75332 7.09168 9.81165 6.96918 9.91665 6.88751C10.0217 6.80585 10.1558 6.77085 10.2842 6.80001L11.4683 7.06251C12.6292 7.31918 13.2125 8.00168 13.2475 9.16251C13.2475 9.17418 13.2475 9.18585 13.2475 9.19751C13.2008 10.125 12.4367 10.8542 11.5033 10.8542ZM10.6283 7.76835V9.10418C10.6283 9.58835 11.0192 9.97918 11.5033 9.97918C11.9642 9.97918 12.3433 9.62335 12.3725 9.16835C12.3433 8.43335 12.04 8.08335 11.2817 7.91418L10.6283 7.76835Z"
        fill={color}
      />
    </svg>
  );
}
EntityIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
EntityIcon.defaultProps = {
  color: '#ffffff',
  size: '14',
};
export function TransferIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 0.333008C3.32016 0.333008 0.333496 3.31967 0.333496 6.99967C0.333496 10.6797 3.32016 13.6663 7.00016 13.6663C10.6802 13.6663 13.6668 10.6797 13.6668 6.99967C13.6668 3.31967 10.6802 0.333008 7.00016 0.333008ZM10.4602 9.62634C10.4335 9.68634 10.4002 9.73967 10.3535 9.78634L9.22683 10.913C9.12683 11.013 9.00016 11.0597 8.8735 11.0597C8.74683 11.0597 8.62016 11.013 8.52016 10.913C8.32683 10.7197 8.32683 10.3997 8.52016 10.2063L8.7935 9.93301H5.06683C4.20016 9.93301 3.50016 9.22634 3.50016 8.36634V7.18634C3.50016 6.91301 3.72683 6.68634 4.00016 6.68634C4.2735 6.68634 4.50016 6.91301 4.50016 7.18634V8.36634C4.50016 8.67967 4.7535 8.93301 5.06683 8.93301H8.7935L8.52016 8.65967C8.32683 8.46634 8.32683 8.14634 8.52016 7.95301C8.7135 7.75967 9.0335 7.75967 9.22683 7.95301L10.3535 9.07967C10.4002 9.12634 10.4335 9.17967 10.4602 9.23967C10.5135 9.36634 10.5135 9.50634 10.4602 9.62634ZM10.5002 6.81301C10.5002 7.08634 10.2735 7.31301 10.0002 7.31301C9.72683 7.31301 9.50016 7.08634 9.50016 6.81301V5.63301C9.50016 5.31967 9.24683 5.06634 8.9335 5.06634H5.20683L5.48016 5.33301C5.6735 5.52634 5.6735 5.84634 5.48016 6.03967C5.38016 6.13967 5.2535 6.18634 5.12683 6.18634C5.00016 6.18634 4.8735 6.13967 4.7735 6.03967L3.64683 4.91301C3.60016 4.86634 3.56683 4.81301 3.54016 4.75301C3.48683 4.63301 3.48683 4.49301 3.54016 4.37301C3.56683 4.31301 3.60016 4.25301 3.64683 4.20634L4.7735 3.07967C4.96683 2.88634 5.28683 2.88634 5.48016 3.07967C5.6735 3.27301 5.6735 3.59301 5.48016 3.78634L5.20683 4.05967H8.9335C9.80016 4.05967 10.5002 4.76634 10.5002 5.62634V6.81301Z"
        fill={color}
      />
    </svg>
  );
}
TransferIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
TransferIcon.defaultProps = {
  color: '#603ACB',
  size: '0.972vw',
};
